import {citiesList} from "@/composables/list/cities.list";

/**
 * Тип для ключей регионов
 */
export type RegionKey = keyof typeof citiesList;

/**
 * Получает название региона по его ключу
 * @param key - Ключ региона
 * @returns Название региона или null если ключ не передан
 */
export function getRegionName(key: RegionKey | null | undefined): string | null {
  return key ? citiesList[key] : null;
}